// @flow strict
import styled from "styled-components";

const DesktopOnly = styled.div.attrs({ className: "hidden-xs hidden-sm" })``;

export default DesktopOnly;
